<template>
   <div class="main">
        <div class="nav">
            <Nav :title="'面访详情'" :arrow ="true"></Nav>
        </div>
        <div>
            <van-panel title="基本信息">
            </van-panel>
            <van-form>
                <van-field v-model="fromdata.subject" name="主题" label="主题" placeholder="主题" disabled
                    :rules="[{ required: true, message: '请填写主题' }]" />
                <van-field v-model="fromdata.client" name="相关客户" label="相关客户" placeholder="相关客户" disabled
                    :rules="[{ required: true, message: '请填写相关客户' }]" />
                <van-field v-model="fromdata.assignee" name="被分配人" label="被分配人" placeholder="被分配人" disabled
                    :rules="[{ required: true, message: '请填写被分配人' }]" />
                <van-field v-model="fromdata.visiting_personnel" name="参与拜访人" label="参与拜访人" placeholder="参与拜访人" disabled
                    :rules="[{ required: true, message: '请填写被参与拜访人' }]" />
                <van-field v-model="fromdata.visiting_contents" type="textarea" name="拜访内容" label="拜访内容" placeholder="拜访内容" rows="1" disabled
                    autosize :rules="[{ required: true, message: '请填写拜访内容' }]" />

               
            </van-form>
            <van-panel title="系统信息">
                <div class="baifang">
                    <div class="item">拜访地址</div>
                    <div class="item">{{fromdata.location_title}}</div>
                    <div class="item">拜访来源</div>
                    <div class="item">{{fromdata.visiting_source}}</div>
                    <div class="item">拍照打卡</div>
                    <div class="image">
                        <van-image

  fit="contain"
  :src="fromdata.oss_attachments[0]"
/>
                    </div>
                    
                </div>
            </van-panel>
            
        </div>
   </div>
</template>

<script>
import Nav from './component/nav.vue';
import { qiweiAPI } from '../../api/qiwei.js';
export default {
    data() {
        return {
            zhuti: '',
            baifangtext: '',
            username: '',
            username1: '',
            fromdata:{

            }
        }
    },
    mounted(){
        console.log(this.$route.query);
        this.getSignInDetails({
            id:this.$route.query.getSignInDetails,
            // qw_user_id: this.$t.qiwei_yuangong_num
        })
    },
    methods: {

        getSignInDetails(params){
            this.$axios.get(qiweiAPI.getSignInDetails, {params,
                  headers: this.$t.headers,})
            .then(res=>{
                console.log(res);
                if(res.data.code==1){
                    this.fromdata = res.data.data
                }

            })
        }
        
    },
    components: {
        Nav,
    },
}
</script>

<style>
.main {
    width: 100%;
}
.baifang{
    font-size: 14px;
    margin: 10px 30px;
}
.item{
    margin: 10px 0;
}
.image{
    width: 100%;
    overflow: hidden;
}
.image>.van-image{
    width: 100%;
    overflow: hidden;
}
.image img{
    width: 100%;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/interviewinginfo.vue